const DefaultToTrue = function () {
  return true
}

export default DefaultToTrue
